import LinkWithQuery from 'src/app/components/Elements/LinkWithQuery';
import { hipaa, privacy, termsAndConditions } from 'src/app/router/paths';

const TosLink = () => {
  return (
    <LinkWithQuery to={termsAndConditions.toPath()} target="_blank">
      Capsule Terms of Service
    </LinkWithQuery>
  );
};

const PrivacyLink = () => (
  <LinkWithQuery to={privacy.toPath()} target="_blank">
    Privacy Policy
  </LinkWithQuery>
);

const HipaaLink = () => (
  <LinkWithQuery to={hipaa.toPath()} target="_blank">
    HIPAA Policy
  </LinkWithQuery>
);

export const TermsOfService = () => {
  return (
    <>
      By clicking continue, I accept the <TosLink />, <PrivacyLink />, and <HipaaLink />
    </>
  );
};

export const RecaptchaTerms = () => (
  <>
    This site is also protected by reCAPTCHA, and the Google{' '}
    <a href="https://policies.google.com/privacy" target="_blank">
      Privacy Policy
    </a>{' '}
    and{' '}
    <a href="https://policies.google.com/terms" target="_blank">
      Terms of Service
    </a>{' '}
    apply.
  </>
);
